const config = {
    debug: false,
    CABINET_CHECK_DUEDATE_SPAN: parse(process.env.VUE_APP_CABINET_CHECK_DUEDATE_SPAN, 14),
    AUTH_SERVER_URI: parse(process.env.VUE_APP_AUTH_SERVER_URL, ""),
    SF_SERVER_URI: parse(process.env.VUE_APP_SF_SERVER_URI, ""),
    JIRA_SERVER_URI: parse(process.env.VUE_APP_JIRA_SERVER_URI, ""),
    JIRA_SONNEN_SERVICE_URI: parse(process.env.VUE_APP_JIRA_SERVICE_URI, ""),
    SF_SERVER_TOKEN: parse(process.env.VUE_APP_SF_SERVER_TOKEN, ""),
    JIRA_SERVER_TOKEN: parse(process.env.VUE_APP_JIRA_SERVER_TOKEN, ""),
    SONNEN_JIRA_PROJECT: parse(process.env.VUE_APP_SONNEN_JIRA_PROJECT_URL, ""),
    features: {}
};

function feature(name) {
    return config.features[name];
}
function parse(value, fallback) {
    if (typeof value === "undefined") {
        return fallback;
    }
    switch (typeof fallback) {
        case "boolean":
            return !!JSON.parse(value);
        case "number":
            return JSON.parse(value);
        default:
            return value;
    }
}

export { config };

export default {
    install(Vue) {
        Vue.appConfig = config;
        Vue.feature = feature;
        Vue.prototype.$appConfig = config;
        Vue.prototype.$feature = feature;
    }
};
